import React from "react";
import LabeledSelect from "./LabeledSelect";

export default function FilterBar({
  filters = [],
  filterValues = {},
  onFilterChange,
  onApply,
  extra,
}) {
  return (
    <div className="flex gap-3 flex-wrap items-end mb-6">
      {filters.map((f) => (
        <LabeledSelect
          key={f.key}
          label={f.label}
          value={filterValues[f.key] ?? ""}
          onChange={(e) => onFilterChange(f.key, e.target.value)}
          options={f.options || []}
          defaultLabel={f.defaultLabel}
          disabled={f.disabled}
        />
      ))}
      {extra}
      <button
        onClick={onApply}
        className="px-6 py-2.5 bg-[#D9FBD4] text-green-600 border rounded-lg text-sm font-semibold hover:bg-green-100 transition self-end"
      >
        Apply
      </button>
    </div>
  );
}
